import { Autoplay, Pagination, Parallax } from 'swiper';

import { Slider } from './slider';

class MvSlider extends Slider {
  constructor(container, parameters, playButton) {
    super(container, parameters);
    this.playButton = playButton;
    this.isRunning = true;
  }

  init() {
    super.init();

    this.playButton?.addEventListener('click', () => {
      if (this.isRunning) {
        this.stopLoop();
      } else {
        this.playLoop();
      }
    });
  }

  playLoop() {
    this.instance.autoplay.start();
    this.instance.pagination.update();
    this.container?.classList.remove('_isStop');
    this.isRunning = true;
  }

  stopLoop() {
    this.instance.autoplay.stop();
    this.instance.pagination.bullets.forEach((bullet) =>
      bullet.classList.remove('swiper-pagination-bullet-active'),
    );
    this.container?.classList.add('_isStop');
    this.isRunning = false;
  }
}

export const mvSlider = () => {
  const wraps = document.querySelectorAll('.js-slider-mv');
  wraps.forEach((wrap) => {
    const container = wrap.querySelector('.swiper');
    if (!container) return;
    const slides = container.querySelectorAll('.swiper-slide');
    const contents = wrap.querySelectorAll('.js-slider-mv-content');
    const playButton = wrap.querySelector('.js-slider-mv-play');

    if (slides.length <= 1) {
      playButton.setAttribute('style', 'display:none;');
    }

    const parameters = {
      modules: [Autoplay, Pagination, Parallax],
      slidesPerView: 1,
      loop: slides.length > 1,
      loopAdditionalSlides: slides.length,
      speed: 1000,
      parallax: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (i, className) => `
            <button class="${className}">
              <span class="round">
                <svg class="progress" width="500" height="500" viewBox="0 0 500 500">
                  <path d="M 240 250 A 10 10 0 1 0 260 250 A 10 10 0 1 0 240 250" />
                </svg>
              </span>
            </button>
          `,
      },
      on: {
        init: (swiper) => {
          const bullets = container.querySelectorAll('.swiper-pagination-bullet');
          bullets.forEach((bullet) => {
            bullet.style.setProperty('--progress-time', '4s');
          });
          contents.forEach((content) => {
            const currentContent = contents[swiper.realIndex];
            content.setAttribute('aria-hidden', 'true');
            currentContent.setAttribute('aria-hidden', 'false');
          });
        },
        slideChange: () => {
          const bullets = container.querySelectorAll('.swiper-pagination-bullet');
          bullets.forEach((bullet) => {
            bullet.style.setProperty('--progress-time', '5s');
          });
        },
        slideChangeTransitionStart: (swiper) => {
          contents.forEach((content) => {
            const currentContent = contents[swiper.realIndex];
            content.setAttribute('aria-hidden', 'true');
            currentContent.setAttribute('aria-hidden', 'false');
            content.setAttribute('tabindex', '-1');
            currentContent.setAttribute('tabindex', '0');
          });
        },
      },
    };

    const mvSliderInstance = new MvSlider(container, parameters, playButton);

    mvSliderInstance.init();
  });
};
